import { privateAxios } from "@/common/api/axios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseGovernmentAllocationsBranchesToDistributeProps<T> = {
  filters?: {
    governmentAllocationId?: string
    search?: string
    pageSize?: number
  }
  mapper?: (data: any) => T,
}

export const useGovernmentAllocationsBranchesToDistribute = <T,>({
  filters: { governmentAllocationId, search, pageSize = 50 } = {},
  mapper = Mapper.default<T>(),
}: UseGovernmentAllocationsBranchesToDistributeProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['governmentAllocationsBranchesToDistribute', governmentAllocationId, search, pageSize],
    queryFn: () => {
      return privateAxios.get(`/billing/government_allocations/${governmentAllocationId}/branches_to_distribute`, {
        params: {
          search,
          page_size: pageSize,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}